import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const state = {
    numIndex: 0,
    nameIndex: '',
    dorpIndex: sessionStorage.getItem('dropIndex') || 0,
    menuList: [],
    menuListLength: 0,
    isShow: true
}
const mutations = {
    SET_NUM_INDEX(state, index) {
        state.numIndex = Number(index)
        sessionStorage.setItem("navIndex", index);
        switch (state.numIndex) {
            case 0:
                state.nameIndex = '首页'
                break;
            case 1:
                state.nameIndex = '关于我们'
                break;
            case 2:
                state.nameIndex = '主营业务'
                break;
            case 3:
                state.nameIndex = '项目案例'
                break;
            case 4:
                state.nameIndex = '新闻动态'
                break;
            case 5:
                state.nameIndex = '企业党建'
                break;
            case 6:
                state.nameIndex = '感知与收获'
                break;
        }
    },
    SET_DORPINDEX(state, index) {
        sessionStorage.setItem("dropIndex", index);
        state.dorpIndex = String(index)
    },
    // 面包屑
    SET_MENULISTCHANGE(state, data) {
        state.menuList = data
        state.menuListLength = data.length
    },
    SET_ADDMENU(state, data) {
        state.menuList.push(data)
    },
}
export default new Vuex.Store({
    state,
    mutations
})


// WEBPACK FOOTER //
// ./src/store/index.js